/**
 * Page: Recovery (Journey-Based)
 *
 * Page de récupération de mot de passe par email.
 * Démarre le journey RECOVERY.
 */

import { authContext } from '@/scripts/utils/auth-context.js';
import { alert } from '@/scripts/utils/alert-message.js';

document.addEventListener('DOMContentLoaded', async () => {
  // ============================================
  // INITIALIZATION
  // ============================================
  await authContext.init();

  const currentJourney = authContext.getCurrentJourney();
  const currentState = authContext.getCurrentState();

  // ✅ Si aucun journey en cours + déjà connecté → rediriger vers settings
  if (!currentJourney && authContext.isAuthenticated()) {
    window.location.href = '/settings.html';
    return;
  }

  // ============================================
  // JOURNEY VALIDATION (Entry Point Pattern)
  // ============================================
  // Si journey en cours mais pas de type RECOVERY → clear + rester
  if (currentJourney && currentJourney.name !== 'RECOVERY') {
    authContext.clearJourney();
    alert.info('#alert-container', 'Vous pouvez commencer une récupération de mot de passe.', {
      icon: true,
      closable: true
    });
  }
  // ============================================
  // UI SETUP
  // ============================================
  const emailForm = document.querySelector('[data-step="email"]');
  const sentStep = document.querySelector('[data-step="sent"]');
  const emailDisplay = document.querySelector('[data-email-display]');
  const resendBtn = document.querySelector('[data-resend]');

  if (!emailForm || !sentStep) return;

  // Si email déjà envoyé, afficher la confirmation

  if (currentJourney?.name === 'RECOVERY' && currentState?.name === 'otp_verification') {
    const email = authContext.get('recoveryEmail');
    const flowId = authContext.get('recoveryFlowId');

    if (email && flowId) {
      emailForm.classList.add('hidden');
      sentStep.classList.remove('hidden');
      if (emailDisplay) emailDisplay.textContent = email;

      // Créer et afficher le lien vers la page de vérification avec timer
      createVerificationLink(sentStep, flowId);
    }
  }

  // ============================================
  // FORM SUBMISSION
  // ============================================
  emailForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(emailForm);
    const email = formData.get('email');
    const submitButton = emailForm.querySelector('button[type="submit"]');

    submitButton.disabled = true;
    submitButton.textContent = 'Envoi en cours...';

    try {
      authContext.startJourney('RECOVERY', 'email_input');

      authContext.save('recoveryEmail', email);

      await authContext.executeCurrentState();

      // Si succès, afficher confirmation
      const flowId = authContext.get('recoveryFlowId');
      if (flowId) {
        emailForm.classList.add('hidden');
        sentStep.classList.remove('hidden');
        if (emailDisplay) emailDisplay.textContent = email;

        createVerificationLink(sentStep, flowId);
      }

    } catch (error) {
      console.error('[Recovery] Error sending recovery email:', error);
      submitButton.disabled = false;
      submitButton.textContent = 'Envoyer le lien';
    }
  });

  // ============================================
  // RESEND CODE
  // ============================================
  if (resendBtn) {
    resendBtn.addEventListener('click', async () => {
      const email = authContext.get('recoveryEmail') || emailDisplay?.textContent;
      if (!email) return;

      try {
        authContext.startJourney('RECOVERY', 'email_input');

        authContext.save('recoveryEmail', email);

        await authContext.executeCurrentState();

      } catch (error) {
        console.error('[Recovery] Error resending email:', error);
      }
    });
  }

  // ============================================
  // HELPER: Create Verification Link with Timer
  // ============================================
  function createVerificationLink(container, flowId) {
    const existingLink = container.querySelector('.verification-link-container');
    if (existingLink) existingLink.remove();

    const verificationLink = document.createElement('div');
    verificationLink.className = 'verification-link-container mt-4 p-4 bg-secondary-50 rounded-lg';
    verificationLink.innerHTML = `
      <div class="flex items-start gap-3">
        <svg class="w-5 h-5 text-secondary-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
        </svg>
        <div class="flex-1">
          <p class="text-sm text-secondary-800 font-medium mb-2">
            Un email avec un code de vérification a été envoyé
          </p>
          <div class="space-y-2">
            <a href="/verification-recovery.html?flow=${flowId}"
               class="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700">
              <span>Entrer le code maintenant</span>
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </a>
            <p class="text-xs text-gray-600">
              Redirection automatique dans <span id="countdown-timer" class="font-medium text-primary-600">30</span> secondes
            </p>
          </div>
        </div>
      </div>
    `;
    container.appendChild(verificationLink);

    // Timer de 30 secondes pour auto-redirection
    let countdown = 30;
    const countdownElement = document.getElementById('countdown-timer');
    const countdownInterval = setInterval(() => {
      countdown--;
      if (countdownElement) {
        countdownElement.textContent = countdown;
      }

      if (countdown <= 0) {
        clearInterval(countdownInterval);
        window.location.href = `/verification-recovery.html?flow=${flowId}`;
      }
    }, 1000);
  }
});
